import cboMetadata from './data/metadata.json';
import type { CboDataVersion } from './types.js';

export const CBO_DATA_VERSION: CboDataVersion = cboMetadata as CboDataVersion;
